import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FruitRatingList } from "@/components/reflection/FruitRatingList";
import { ReflectionHeader } from "@/components/reflection/ReflectionHeader";
import { ReflectionNotes } from "@/components/reflection/ReflectionNotes";
import { ReflectionSettings } from "@/components/reflection/ReflectionSettings";
import { ScaleGuide } from "@/components/reflection/ScaleGuide";
import { useReflectionForm } from "@/hooks/useReflectionForm";

export const ReflectionForm = () => {
  const reflection = useReflectionForm();

  return (
    <main className="devotional-shell min-h-screen px-4 py-8 sm:px-6 lg:px-8" data-testid="reflection-page">
      <form onSubmit={reflection.submitReflection} className="mx-auto max-w-5xl space-y-8" data-testid="reflection-form">
        <ReflectionHeader />
        <ScaleGuide />
        <ReflectionSettings average={reflection.average} period={reflection.period} reflectionDate={reflection.reflectionDate} onDateChange={reflection.setReflectionDate} onPeriodChange={reflection.setPeriod} />
        <FruitRatingList ratings={reflection.ratings} onRatingChange={reflection.setRating} />
        <ReflectionNotes
          isMonthly={reflection.period === "monthly"}
          monthlySummary={reflection.monthlySummary}
          notes={reflection.notes}
          promptResponse={reflection.promptResponse}
          onMonthlySummaryChange={reflection.setMonthlySummary}
          onNotesChange={reflection.setNotes}
          onPromptChange={reflection.setPromptResponse}
        />

        <div className="flex justify-end pb-10" data-testid="reflection-submit-row">
          <Button type="submit" disabled={reflection.saving} data-testid="reflection-submit-button" className="h-12 rounded-full bg-[#1A3626] px-8 text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#4A5D4E]">
            {reflection.saving ? <Loader2 className="animate-spin" size={17} /> : <Save size={17} />}
            Save reflection
          </Button>
        </div>
      </form>
    </main>
  );
};